import React from "react";
import { Button, Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import { scrollToElement } from "@/utils/scrollToElement";
import { TableFooter } from "./constants";

const PricingFooter = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack mt={2} spacing={8}>
      <Button
        variant={BUTTON_VARIANTS.IDEAL}
        onClick={() => scrollToElement("contact-us", 120)}
        mt={2}
        alignSelf={"center"}
        justifySelf={"center"}
      >
        Ready To Buy?
      </Button>
      <Text variant={TextVariant} color="text.100" fontStyle={"italic"}>
        {TableFooter.text1}
      </Text>
    </Stack>
  );
};

export default PricingFooter;
